export class Parameter {
    userCode: string;

    brandId: string;

    applicationStatusCode: string;

    occupationCode: string;

    dateOfBirth: string="";

    dealerCode: string;

    modelCode: string;

    variantCode: string;

    productCode: string;

    portfolioId :number;

    newQuotFlag : number; // flag to idnetify the type of car selected

    //usedVehBank : string; // selected bank name

    usedVehBrandId;

}